import { render, staticRenderFns } from "./register.vue?vue&type=template&id=64c69238&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=64c69238&prod&lang=less&scoped=true"
import style1 from "./register.vue?vue&type=style&index=1&id=64c69238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c69238",
  null
  
)

export default component.exports